import {useState} from "react";
import {defaultProviderInfo, IProvider, OfficeLocation} from "../providerContext";
import {FailCallback, sendRequest} from "../../util/http/HTTP";
import {ApiCampaign, ApiLogIn} from "../../util/http/API";
import {mPrint} from "../../util/mPrint";

export default function useProviderAuth() {
    const [provider, setProvider] = useState<IProvider | null>(defaultProviderInfo)

    const parseLoginToken = (token: string, success: () => void, fail: FailCallback) => {
        const param = {
            token: token,
        }
        sendRequest(ApiLogIn.updateTokenToCookie, param, (response) => {
            if (response && response.code === 0) {
                success && success()
            }
        }, fail)
    }

    const getCurrentProfileInfo = (success: (provider: IProvider) => void, fail: FailCallback) => {
        const param = {}
        sendRequest(ApiLogIn.getCurrentProfileInfo, param, (response) => {
            if (response && response.code === 0 && response.data) {
                const {data} = response
                const {doctorInfo, clinicLocations} = data
                let officeLocations: Array<OfficeLocation> = []
                if (clinicLocations && clinicLocations.length) {
                    officeLocations = clinicLocations.filter((_loc: any) => _loc.olid).map((_loc: any) => {
                        return {
                            clinicID: _loc.clinicID,
                            olid: _loc.olid,
                            mEmployeeID: doctorInfo.mEmployeeID,
                            clinicName: _loc.name,
                            address: _loc.address,
                            city: _loc.city,
                            state: _loc.state,
                            zip: _loc.zip,
                            phone: _loc.phone,
                            latitude: 0,
                            longitude: 0,
                        }
                    })
                }
                const provider: IProvider = {
                    employeeRole: doctorInfo.employeeRole,
                    clinicID: doctorInfo.clinicID,
                    clinicName: doctorInfo.clinicName,
                    employeeID: doctorInfo.employeeID,
                    mEmployeeID: doctorInfo.mEmployeeID,
                    employeeFirstName: doctorInfo.employeeFirstName,
                    employeeLastName: doctorInfo.employeeLastName,
                    employeeMidName: doctorInfo.employeeMidName,
                    clientId: doctorInfo.clientId,
                    expireTimeTicks: doctorInfo.expireTimeTicks,
                    officeLocations: officeLocations,
                    doctorPublicURL: data.doctorPublicUrl,
                    clinicOnlineScheduleEnable: false,
                }
                success && success(provider)
            }
        }, fail)
    }

    const login = (token: string, success: (provider: IProvider) => void, fail: FailCallback) => {
        if (token && token.length > 20) {
            parseLoginToken(token, () => {
                getCurrentProfileInfo((provider) => {
                    updateDoctorLinkAvailableStatus(provider, (provider) => {
                        setProvider(provider)
                        success && success(provider)
                    })
                }, fail)
            }, fail)
        } else {
            getCurrentProfileInfo((provider) => {
                updateDoctorLinkAvailableStatus(provider, (provider) => {
                    setProvider(provider)
                    success && success(provider)
                })
            }, fail)
        }
    }

    const updateDoctorLinkAvailableStatus = (provider: IProvider, success: (provider: IProvider) => void) => {
        const param = {
            clinicID: provider.clinicID,
        }
        sendRequest(ApiCampaign.isDoctorLinkAvailable, param, (response) => {
            provider.clinicOnlineScheduleEnable = response?.data
            success(provider)
        }, (error) => {
            mPrint(error)
            success(provider)
        })
    }

    const logOut = () => {
        mPrint("log out")
    }

    return {
        provider,
        login,
        logOut,
    }
}
